import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { baseQuery } from '../../services/http-client.factory';

const api = createApi({
	reducerPath: 'api',
	baseQuery,
	endpoints: () => ({}),
});

export default api;
